import footerStyles from "../app-footer/app-footer.style.module.scss";
import styles from "./app-header.style.module.scss";

let/mobileMenu=false
let/searchOpen=false
script --
  document.documentElement.classList.toggle("show-mobile-menu", mobileMenu);

// Global Cmd+K shortcut
script --
  document.addEventListener(
    "keydown",
    (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        searchOpen = !searchOpen;
      }
    },
    { signal: $signal },
  );

header#header
  a
    ,title="Home"
    ,href="/"
    ,id=styles.logo
    ,onContextMenu(e) {
      e.preventDefault();
      window.location.href = "/brand";
    }
    picture
      source srcset="/assets/logo.svg#dark" media="(prefers-color-scheme:dark)"
      img alt="Marko Logo" src="/assets/logo.svg"

  div class=styles.pageLinks
    a href="/docs" -- Docs
    a href="/playground" -- Playground
    a href="https://github.com/marko-js/marko" -- GitHub

  button
    ,onClick() {
      mobileMenu = !mobileMenu;
    }
    ,aria-pressed=(mobileMenu ? "true" : "false")
    ,aria-label=`${mobileMenu ? "Hide" : "Show"} menu`
    ,id=styles.hamburger

  div
    ,onClick() {
      mobileMenu = false;
    }
    ,id=styles.search
    button
      ,aria-label="Search docs (Cmd+K)"
      ,onClick() {
        searchOpen = true;
      }
      kbd -- K
      html-script --
        ${
          `document.currentScript.previousElementSibling.prepend(navigator.platform.startsWith("Mac")?"\u2318":"ctrl+")`
        };

search-dialog open:=searchOpen

script --
  onLoad(() => {
    if ("ScrollTimeline" in window) {
      setupStickyScroll();
    }
  });
static function onLoad(cb: () => void) {
  if (document.readyState === "interactive") {
    cb();
  } else {
    document.addEventListener("DOMContentLoaded", cb);
  }
}
static function setupStickyScroll() {
  const vp = visualViewport!;
  const html = document.documentElement;
  const header = document.getElementById("header")!;
  const footer = document.getElementById(footerStyles.footer)!;
  let stickTop = 0;
  let prevY = window.scrollY;
  let prevUp: boolean | undefined;
  window.addEventListener(
    "scroll",
    () => {
      const y = window.scrollY;
      const up = y < prevY;
      if (prevY === (prevY = y)) return;
      if (y > 0) {
        if (prevUp === (prevUp = up)) return;
      } else {
        stickTop = 0;
      }

      const stickSize = header.offsetHeight;
      const stickMax = Math.max(
        0,
        html.scrollHeight - vp.height - stickSize - footer.offsetHeight * 2,
      );
      stickTop = up
        ? Math.max(0, stickTop, Math.min(stickMax, y - stickSize))
        : Math.min(stickMax, stickTop, y);
      html.style.setProperty("--stick-top", `${stickTop}px`);
      html.classList.toggle("scrolled", stickTop > 0);
    },
    { passive: true },
  );
}
